<template>
  <b-modal size="lg" v-model="show" centered title="Neuer Sachbearbeiter"
  >
      <b-row class="justify-content-md-center">
        <b-col>
          <label for="name">Name</label>
          <b-form-input id="name" type="text"
                        v-model="sach.name"
                        class="mb-2 text-black"
                        maxlength="20"
          ></b-form-input>
          <b-form-text style="text-align: right">{{sach.name.length}}/20</b-form-text>
          <label for="name">Schlüsselfeld</label>
          <b-form-input id="name" type="text"
                        v-model="sach.access"
                        class="mb-2 text-black"
                        maxlength="50"
          ></b-form-input>
          <b-form-text style="text-align: right">{{sach.access.length}}/80</b-form-text>
          <b-row>
            <b-col sm="5">
              <label for="plz">Amt</label>
              <b-form-input id="plz" type="text"
                            v-model="sach.office"
                            class="mb-2 text-black"
                            maxlength="30"
              ></b-form-input>
              <b-form-text style="text-align: right">{{sach.office.length}}/30</b-form-text>
            </b-col>
            <b-col sm="5">
              <label for="ort">Abteilung</label>
              <b-form-input id="ort" type="text"
                            v-model="sach.department"
                            class="mb-2 text-black"
                            maxlength="30"
              ></b-form-input>
              <b-form-text style="text-align: right">{{sach.department.length}}/30</b-form-text>
            </b-col>
            <b-col sm="2">
              <label for="ort">Raum</label>
              <b-form-input id="ort" type="text"
                            v-model="sach.room"
                            class="mb-2 text-black"
                            maxlength="10"
              ></b-form-input>
              <b-form-text style="text-align: right">{{sach.room.length}}/10</b-form-text>
            </b-col>
          </b-row>
          <label for="name">Aktenzeichen</label>
          <b-form-input id="name" type="text"
                        v-model="sach.file_number"
                        class="mb-2 text-black"
                        maxlength="50"
          ></b-form-input>
          <b-form-text style="text-align: right">{{sach.file_number.length}}/50</b-form-text>
          <label for="name">Telefon</label>
          <b-form-input id="name" type="tel"
                        v-model="sach.phone"
                        class="mb-2 text-black"
                        maxlength="50"
          ></b-form-input>
          <b-form-text style="text-align: right">{{sach.phone.length}}/20</b-form-text>
          <label for="name">Email</label>
          <b-form-input id="name" type="email"
                        v-model="sach.email"
                        class="mb-2 text-black"
                        maxlength="20"
          ></b-form-input>
          <b-form-text style="text-align: right">{{sach.email.length}}/50</b-form-text>
        </b-col>
      </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: "CreateSachDialog",
  data() {
    return {
      show: false,
      sach: {
        name: '',
        office: '',
        access: '',
        department: '',
        phone: '',
        room: '',
        file_number: '',
        fax: '',
        email: '',
      }
    }
  },
  methods: {
    showModal() {
      this.sach = {
        name: '',
        office: '',
        access: '',
        department: '',
        phone: '',
        room: '',
        file_number: '',
        fax: '',
        email: '',
      };
      this.show = true;
    },
    getReturnData() {
      return this.sach;
    },
    async onSave() {
      let data = this.getReturnData();
      this.$emit('create-sach', data);
      this.show = false;
    },

    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
</style>
